<button
    type="button"
    class="header__bell"
    [class.header__bell--alert]="hayNoLeidas()"
    [pTooltip]="tooltip()"
    tooltipPosition="bottom"
    [attr.aria-label]="tooltip()"
    (click)="abrirPanel()">
    <i class="pi pi-bell" aria-hidden="true"></i>
    @if (hayNoLeidas()) {
        <span class="header__bell-count" aria-hidden="true">{{ contador() }}</span>
    }
</button>

<!-- La lista de avisos, una sola vez: la usan el panel de la campanita y el saludo al entrar -->
<ng-template #listaAvisos>
    @if (loading() && avisos().length === 0) {
        <app-loading-state variant="skeleton-cards" message="Buscando novedades…" [count]="3" />
    } @else if (failed() && avisos().length === 0) {
        <app-empty-state
            icon="pi pi-exclamation-triangle"
            title="No se pudo consultar"
            description="No se pudieron leer las notificaciones. Se reintenta solo en un minuto." />
    } @else if (mostrarVacio()) {
        <app-empty-state
            icon="pi pi-check-circle"
            title="Estás al día"
            description="No tienes notificaciones." />
    } @else {
        <ul class="rbi-notifications">
            @for (aviso of avisos(); track aviso.id) {
                <li class="rbi-notifications__item">
                    <button
                        type="button"
                        class="rbi-notifications__link"
                        [class.rbi-notifications__link--unread]="!aviso.read"
                        (click)="abrirAviso(aviso.id)">
                        <span class="rbi-notifications__icon" [class]="'rbi-notifications__icon--' + aviso.tone">
                            <i [class]="aviso.icon" aria-hidden="true"></i>
                        </span>
                        <span class="rbi-notifications__body">
                            <span class="rbi-notifications__title">{{ aviso.title }}</span>
                            <span class="rbi-notifications__meta">{{ aviso.detail }}</span>
                            <span class="rbi-notifications__meta">{{ aviso.fecha }}</span>
                        </span>
                        @if (!aviso.read) {
                            <span class="rbi-notifications__dot" aria-label="Sin leer"></span>
                        }
                    </button>
                </li>
            }
        </ul>
    }
</ng-template>

<!-- La campanita: se consulta cuando uno quiere, así que no tapa la pantalla -->
@defer (when panelAbierto()) {
    <app-drawer
        [visible]="panelAbierto()"
        (closed)="cerrarPanel()"
        size="sm"
        icon="pi pi-bell"
        eyebrow="NOTIFICACIONES"
        title="Tus notificaciones"
        [subtitle]="subtitulo()">

        <ng-container [ngTemplateOutlet]="listaAvisos"></ng-container>

        @if (hayNoLeidas()) {
            <div drawer-footer class="rbi-notifications__footer">
                <button type="button" class="rbi-notifications__mark-all" (click)="marcarTodas()">
                    <i class="pi pi-check" aria-hidden="true"></i> Marcar todas como leídas
                </button>
            </div>
        }
    </app-drawer>
}

<!-- El saludo al entrar: va al frente y con el fondo atenuado, porque nadie lo pidió y hay
     algo esperando una decisión. -->
@defer (when saludoAbierto()) {
    <app-dialog
        [visible]="saludoAbierto()"
        icon="pi pi-bell"
        title="Tienes notificaciones sin leer"
        [subtitle]="subtitulo()"
        size="md"
        [dismissableMask]="true"
        [showPrimary]="false"
        cancelLabel="Ver más tarde"
        (cancel)="cerrarSaludo()">

        <ng-container [ngTemplateOutlet]="listaAvisos"></ng-container>
    </app-dialog>
}
